import * as React from "react";
const SvgFiRrRiskAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-risk-alt_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-5.969-5.969A9.95 9.95 0 0 0 20 10c0-5.514-4.486-10-10-10S0 4.486 0 10s4.486 10 10 10c2.398 0 4.6-.85 6.324-2.262l5.969 5.969a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m9.224-5.297a1.416 1.416 0 0 0-2.447 0L4.596 11.87c-.551.944.13 2.13 1.224 2.13h8.361a1.417 1.417 0 0 0 1.224-2.13zM10 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2m1-4a1 1 0 0 1-2 0V7a1 1 0 0 1 2 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-risk-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRiskAlt;
